// Estilo
import estilo from './pageContact.module.css';

// Componentes
import Background from "../../elements/backgrounds/background";
import LabelMenu from '../../elements/labels/labelMenu';

// Data
import { HREF } from "../../../utils/varGlobal";

function PageContact(){
    return (
        <main>
            <Background verImagen={false}>
                <LabelMenu opcion='contact' goBack={true}/>
                <a id={estilo.text} href={"mailto:" + HREF.MAIL}>
                    {HREF.MAIL}
                </a>
            </Background>
        </main>
    )
}

export default PageContact;